module.exports = __webpack_public_path__ + "img/Group 8908white.473b04a5.svg";